export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_LOADING = 'AUTH_LOADING';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_UPDATE_USER = 'AUTH_UPDATE_USER';
export const AUTH_CHECK_LAST_VISITED_PAGE = 'AUTH_CHECK_LAST_VISITED_PAGE'
